<template>
    <v-container fluid>
        <v-row v-if="!showFeedbackData">
            <v-col cols="12" style="height: 75dvh; overflow-y: auto; width: 100dvw">
                <!-- Sticky Search Bar Inside Scrollable Area -->
                <div
                    style="position: sticky;top: 0;background-color: white;z-index: 2;padding-top: 8px;padding-bottom: 8px;">
                    <v-text-field label="search here..." prepend-inner-icon="bx bx-search" outlined dense
                        v-model="searchValue" />
                </div>

                <!-- Feedback Cards Grid -->
                <v-row>
                    <v-col v-for="(feedback, feedbackIndex) in getFeedbacks" :key="feedbackIndex" cols="12" sm="6"
                        md="4" lg="3">
                        <v-card elevation="0" style="border: 1px solid #00000022" class="pa-2">
                            <v-card-title>
                                <v-icon style="color: black; font-size: 1.2rem">bx bxs-user</v-icon>
                                <span style="font-size: 1rem; font-weight: 500">
                                    {{ feedback.wrote_by?.name }}
                                </span>
                                <v-spacer />
                                <v-icon class="icon-button"
                                    style="color: black;font-size: 0.9rem;cursor: pointer;background-color: #e9e9e944;padding: 8px;border-radius: 20px;"
                                    @click.stop="setFeedbackToViewData(feedback.feedbacks)">
                                    bx bxs-chevrons-right
                                </v-icon>
                            </v-card-title>

                            <v-divider />

                            <v-card-text class="text-center">
                                <div style="font-size: 1rem;font-weight: 600;margin-bottom: 0.5rem;">
                                    No. of
                                    {{ feedback.feedbacks.length > 1 ? "feedbacks" : "feedback" }}
                                </div>
                                <div
                                    style="font-size: 4rem;font-weight: bold;color: #000;background-color: #cccccc55;width: fit-content;margin: 0 auto;padding: 0.5rem 1rem;border-radius: 8px;height: 5dvh;">
                                    <span style="position: relative; top: 10px">
                                        {{ feedback.feedbacks.length }}
                                    </span>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="12" style="height: 78dvh; overflow-y: auto">
                <v-list two-line subheader>
                    <v-subheader
                        style="position: sticky; top: 0;background-color: #f2f2f222; z-index: 1; display: flex; align-items: center;">
                        Feedback
                        <v-spacer />
                        <v-btn icon @click.stop="showFeedbackData = false">
                            <v-icon>bx bxs-chevrons-left</v-icon>
                        </v-btn>
                    </v-subheader>
                    <v-list-item v-for="(fb, fbIndex) in feedbackView" :key="fbIndex"
                        style="border: 1px solid #cccccc22">
                        <v-list-item-content>
                            <v-list-item-title>
                                <span style="font-size: 1.5rem; font-weight: 700">
                                    {{ fbIndex + 1 }}
                                </span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <span style="font-size: 1.2rem; font-weight: 900" v-html="fb.content" />
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data: () => ({
        showFeedbackData: false,
        searchValue: "",
    }),
    async mounted() {
        await this.fetchFeedbacks();
    },
    computed: {
        ...mapGetters({
            feedbacks: "feedback/getFeedbacks",
            feedbackView: "feedback/getFeedbackView",
        }),
        getFeedbacks() {
            if (this.searchValue !== "") {
                return this.feedbacks.filter((q) => {
                    return q.wrote_by?.name
                        ?.toLowerCase()
                        .includes(this.searchValue.toLowerCase());
                });
            }
            return this.feedbacks;
        },
    },
    methods: {
        async fetchFeedbacks() {
            try {
                const response = await this.$axios.get("api/feedback");
                const { data } = response;
                const grouped = data.reduce((acc, item) => {
                    const key = item.wrote_by.id;
                    if (!acc[key]) {
                        acc[key] = {
                            wrote_by: item.wrote_by,
                            feedbacks: [],
                        };
                    }
                    acc[key].feedbacks.push(item);
                    return acc;
                }, {});
                const groupedArray = Object.values(grouped);
                this.$store.dispatch("feedback/setFeedbacks", groupedArray);
            } catch (error) {
                console.log("error on fetching feedback - service layer", error);
            }
        },

        setFeedbackToViewData(data) {
            this.showFeedbackData = true;
            this.$store.dispatch("feedback/setFeedBackView", data);
        },
    },
};
</script>
